import React from "react";
import { Modal } from "reactstrap";
import "assets/css/safexpay-web.css";
import "./Registration.css";
import Spinner from "reactstrap/lib/Spinner";
import CryptoJS from "crypto-js";
import { base_url } from "assets/utils/const";
class SetPassword extends React.Component {
  state = {
    number: false,
    specialChar: false,
    minLength: false,
    upperCase: false,
    lowerCase: false,
    isLoaded: false,
    passwordError: "",
    authToken: localStorage.getItem("TempAuthtoken"),
  };

  componentDidMount() {
    // if (!localStorage.getItem("Authtoken")) {
    //   window.location.href = "/login";
    // }
  }

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };
  handlePasswordChange = (event) => {
    // console.log("length", this.state.minLength);
    const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

    let password = event.target.value;

    //password length
    if (password.length > 7) {
      this.setState({ minLength: true });
    } else {
      this.setState({ minLength: false });
    }

    //password contains numeric value
    if (/^(?=.*\d).+$/.test(password)) {
      this.setState({ number: true });
    } else {
      this.setState({ number: false });
    }

    // password contains lowercase value
    if (/^(?=.*[a-z]).+$/.test(password)) {
      this.setState({ lowerCase: true });
    } else {
      this.setState({ lowerCase: false });
    }

    // password contains uppercase value
    if (/^(?=.*[A-Z]).+$/.test(password)) {
      this.setState({ upperCase: true });
    } else {
      this.setState({ upperCase: false });
    }

    // password contains special char value
    if (/[$-/:-?{-~!"^_`\[\]@#]/.test(password)) {
      this.setState({ specialChar: true });
    } else {
      this.setState({ specialChar: false });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ isLoaded: true, passwordError: "" });

    var uname = localStorage.getItem("umail");
    var upass = event.target.txtPassword.value;
    var ucpass = event.target.txtConfirmPassword.value;
    var key = "oqUl4D0LqA4plZw4reAX/K3UKJoQdet0k/N6X6K4Y5k=";
    var base64IV = "0123456789abcdef";

    var parsedBase64Key = CryptoJS.enc.Base64.parse(key);
    var IV = CryptoJS.enc.Utf8.parse(base64IV);
    // Encryption process
    if (typeof ucpass !== "string") {
      ucpass = ucpass.toString();
    }

    // this is Base64-encoded encrypted data
    var encryptedData1 = CryptoJS.AES.encrypt(upass, parsedBase64Key, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: IV,
    });
    var encryptedData2 = CryptoJS.AES.encrypt(ucpass, parsedBase64Key, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: IV,
    });
    // console.log("encryptedData = ", encryptedData.toString());
    const encryptedCipherText1 = encryptedData1.toString();
    const encryptedCipherText2 = encryptedData2.toString();
    if (upass === ucpass) {
      fetch(`${base_url}api/merchantSetPassword`, {
        method: "PUT",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods":
            "GET, POST, PATCH, PUT, DELETE, OPTIONS",
          "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
          Accept: "application/json",
          "Content-Type": "application/json",
          auth: this.state.authToken,
        },
        body: JSON.stringify({
          ag_id: "paygate",
          user_id: uname,
          set_password: encryptedCipherText1,
          set_confirm_password: encryptedCipherText2,
        }),
      })
        .then((res) => res.json())
        .then(
          (result) => {
            console.log(result);
            this.setState({ isLoaded: false });
            if (result.statusCode == "200") {
              localStorage.clear();
              window.location.href = "/login";
            } else {
              if (
                result.payLoad === `Session Expired Please Login` ||
                result.payLoad === `Incorrect Token`
              ) {
                this.toggleModal("loginModal");
              }
              if (
                result.payLoad &&
                result.payLoad.includes(
                  "Password must not be same as last 5 passwords"
                )
              ) {
                this.setState({ passwordError: result.payLoad.split(":")[1] });
              }
            }
          },
          (error) => {
            this.setState({ isLoaded: false });
            //alert('Failed');
          }
        );
    } else {
      this.setState({ isLoaded: false });
      var lblError = document.getElementById("lblError");
      lblError.classList.remove("d-none");
      lblError.innerText = "Passwords did not match";
    }
  };
  handleLogin = () => {
    this.toggleModal("loginModal");
    window.location.href = "/login";
  };
  render() {
    return (
      <>
        <section className="dv-Registration-content">
          <div className="first-bg"></div>
          <div className="container">
            <div className="row">
              <div
                className="col-md-6 dv-instruction"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <h1 className="section-heading">
                  Quick &amp; Easy Activation Process
                </h1>
                <div className="row">
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 1</div>
                      <div className="text">
                        Check email for Username &amp; OTP.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step">
                      <div className="step">Step 2</div>
                      <div className="text">
                        Enter Username &amp; OTP. <br />
                        Set a desirable password.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step">
                      <div className="step">Step 3</div>
                      <div className="text">
                        Fill in all the details &amp; upload documents to start
                        activation process.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 form-div"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <form
                  onSubmit={this.handleSubmit}
                  className="dv-login-form dv-form"
                >
                  <h1 className="section-heading border-heading">
                    Set Password
                  </h1>

                  <div className="form-group mx-5">
                    <label htmlFor="txtPassword">Password</label>
                    <input
                      type="text"
                      required
                      className="form-control"
                      name="txtPassword"
                      id="txtPassword"
                      placeholder="Enter new password"
                      onChange={this.handlePasswordChange}
                      autoComplete="off"
                    />
                  </div>
                  <div className="form-group mx-5">
                    <label htmlFor="txtConfirmPassword">Confirm Password</label>
                    <input
                      type="Password"
                      required
                      className="form-control"
                      name="txtConfirmPassword"
                      id="txtConfirmPassword"
                      placeholder="****"
                    />
                  </div>
                  <span id="password_strength"></span>

                  <div className="progress-bar_wrap">
                    <div className="progress-bar_item progress-bar_item-1">
                      <p className="text-prog">Weak</p>
                    </div>
                    <div className="progress-bar_item progress-bar_item-2">
                      <p className="text-prog">Medium</p>
                    </div>
                    <div className="progress-bar_item progress-bar_item-3">
                      <p className="text-prog">Strong</p>
                    </div>
                  </div>
                  <div className="form-group mt-4 mx-5">
                    <ul className="lipass">
                      <li
                        style={{
                          textDecoration:
                            this.state.minLength && "line-through",
                        }}
                      >
                        Minimum 8 characters
                      </li>
                      <li
                        style={{
                          textDecoration:
                            this.state.upperCase && "line-through",
                        }}
                      >
                        1 Upper Case
                      </li>
                      <li
                        style={{
                          textDecoration:
                            this.state.lowerCase && "line-through",
                        }}
                      >
                        1 Lower Case
                      </li>
                      <li
                        style={{
                          textDecoration: this.state.number && "line-through",
                        }}
                      >
                        1 Numeric Letter
                      </li>
                      <li
                        style={{
                          textDecoration:
                            this.state.specialChar && "line-through",
                        }}
                      >
                        1 Symbol
                      </li>
                    </ul>
                    <div className="clearfix"></div>
                  </div>
                  <div className="form-group mx-5">
                    <ul className="egPass">
                      <li>Password Tip : Use a PASSPHRASE.</li>
                      <li>A passphrase is a phrase or set of words.</li>
                      <li>eg: c@pricornRgr8</li>
                    </ul>
                    <div className="clearfix"></div>
                  </div>
                  <div className="text-center">
                    <label
                      id="lblError"
                      name="lblError"
                      className="d-none alert alert-danger lblError"
                    ></label>
                  </div>
                  <div className="err" style={{ textAlign: "center" }}>
                    {this.state.passwordError}
                  </div>
                  <div className="btn-holder mt-4 text-center">
                    <input
                      type="text"
                      id="txtPwdCount"
                      name="txtPwdCount"
                      className="d-none"
                    />
                    <button
                      type="submit"
                      id="btnSubmit"
                      className={
                        this.state.isLoaded
                          ? `btn btn-next btn-gradient disable-btn`
                          : `btn btn-next btn-gradient`
                      }
                      disabled={this.state.isLoaded}
                    >
                      Save &amp; Next
                      {this.state.isLoaded ? (
                        <Spinner
                          size="sm"
                          color="light"
                          className="btn-loader"
                        />
                      ) : null}
                    </button>
                  </div>

                  {/* <div className="my-5 py-3"></div> */}

                  <div className="dv-bottom-bg mt-5">
                    <div className="dv-help">
                      Need help?{" "}
                      <a href="/support" className="lnk-contact text-underline">
                        SUPPORT
                      </a>
                    </div>
                    <div className="first-bottom-bg"></div>
                    <div className="second-bottom-bg"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        <Modal
          className="modal-dialog-centered modal-lg loginModal"
          isOpen={this.state.loginModal}
          toggle={() => this.toggleModal("loginModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            {/* <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("loginModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button> */}
            <h5 style={{ textAlign: "center" }}>
              Session Expired, Please Login to continue
            </h5>
            <div className="btn-holder mt-3 text-center">
              <button
                onClick={this.handleLogin}
                className="btn btn-gradient bt-wd"
              >
                Login
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default SetPassword;
